var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dashboard)?_c('div',{staticClass:"dashboard"},[_c('breadcrumb',{attrs:{"items":[{title: _vm.title, to: _vm.$route.path}]}}),_c('page',_vm._b({key:_vm.id},'page',{defsEndpoint: _vm.defsEndpoint, title: _vm.title},false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }